<!--suppress EqualityComparisonWithCoercionJS -->
<template>
  <div class="form-bootstrap-radio" :class="groupClass">
    <label :class="lableClass" :for="name">
      <slot>{{ title }}</slot>
    </label>

    <div :class="fieldClass">
      <div
        class="btn-group-toggle btn-group"
        :class="[buttonsClass, isDisabled ? 'btn-disabled' : '']"
        data-toggle="buttons"
      >
        <template v-if="isSimple">
          <label
            v-for="(option, index) in options"
            :key="index"
            :class="{ active: value == option }"
            class="mx-0 btn btn-outline-secondary"
            @click="update(option)"
          >
            <input
              :checked="value == option"
              :disabled="isDisabled"
              :name="name"
              :value="option"
              type="radio"
            />
            <span class="capitalize">{{ option }}</span>
          </label>
        </template>
        <template v-else>
          <label
            v-for="(option, index) in options"
            :key="index"
            :class="{ active: value == option[trackBy] }"
            class="mx-0 btn btn-outline-secondary"
            @click="update(option)"
          >
            <input
              :checked="value == option[trackBy]"
              :disabled="isDisabled"
              :name="name"
              :value="option[trackBy]"
              type="radio"
              @change="update(option[trackBy])"
            />
            <span class="capitalize">{{ option[label] }}</span>
          </label>
        </template>
      </div>

      <div
        v-if="form && form.errors.has(errorId)"
        class="invalid-feedback"
        v-text="form.errors.get(errorId)"
      ></div>
      <slot name="note"></slot>
    </div>

    <div :class="extraSlotClass">
      <slot name="extra"></slot>
    </div>
  </div>
</template>

<script type="text/babel">
import BaseComponent from "./BaseComponent.vue";

export default {
  extends: BaseComponent,

  props: {
    trackBy: {
      default: "id",
    },
    label: {
      default: "name",
    },
    buttonsClass: {
      default: "mr-3",
    },
  },

  computed: {
    isSimple() {
      let simple = true;
      this.options.forEach((item) => {
        if (typeof item === "object") {
          simple = false;
        }
      });

      return simple;
    },
  },

  methods: {
    update(value) {
      if (this.isDisabled) {
        return;
      }

      if (this.form) {
        this.form.errors.clear(this.errorId);
      }

      this.$emit("input", value);
    },
  },
};
</script>
